import numbro from 'numbro'

export const byteToText = (n: number) =>
  numbro(n).format({
    output: 'byte',
    base: 'binary',
    spaceSeparated: true,
    mantissa: 1,
  })
